import React, {useEffect, useRef} from "react";
import {Drawer as MDrawer} from "@mui/material";
import {checkNull, checkNullJson, checkNullStr, getJsonValue, getDefStr, isBoolTrue, isJsonValueTrue, printError, subtractSize} from "../utils/ReactUtils";
import {Button, CircleLoading, Label} from "../index";
import useScreenSize from "../hook/useScreenSize";

/**
 *
 * @example
 * const [openDrawer, setOpenDrawer] = useState(false);
 * <Drawer
 *             title={'Help'}
 *             subtitle={''}
 *             subtitleAt={'start'}
 *             titleAt={'center'}
 *             titleClassName={'fw-bold fs-normal'}
 *             contentClassName={'px-3'}
 *             subtitleClassName={''}
 *             closeOnEscape={true}
 *             closeOnClickAway={true}
 *             open={openDrawer}
 *             onClose={() => {
 *                 setOpenDrawer(false);
 *             }}>
 *             children
 *         </Drawer>
 */
const Drawer = ({
                    children,
                    open = false,
                    title,
                    subtitle,
                    titleContent,
                    headerClassName = '',
                    titleClassName = '',
                    subtitleClassName = '',
                    closeClassName = '',
                    titleWrapperClassName = '',
                    onOpen,
                    onClose,
                    titleSize,
                    showClose = true,
                    blurredBg = false,
                    closeOnEscape = true,
                    closeOnClickAway = true,
                    closeOnClose = true,
                    detached = false,
                    bg = 'white',
                    width = '50%',
                    widthSm = '85%',
                    height = '100%',
                    titleAt = 'center',
                    subtitleAt = 'center',
                    placement = 'right',
                    closeColor = 'black',
                    backdropColor = 'rgba(0,0,0,.15)',
                    scrollSpeed = 50,
                    headerBg = '',
                    className = '',
                    contentClassName = '',
                    style = {},
                    contentStyle = {},
                    titleStyle = {},
                    subtitleStyle = {},
                    headerStyle = {},
                    loadingStatus = {},
                    closeStyle = {},
                    headerContent,
                    ...rest
                }) => {
    const TAG = 'Drawer';

    const {isScreenXs, isScreenSm, isScreenMd, isScreenLg, isScreenXl, isScreenResizing} = useScreenSize();


    const [openDrawer, setOpenDrawer] = React.useState(false);
    useEffect(() => {
        setOpenDrawer(isBoolTrue(open));
    }, [open]);

    const scrollViewRef = useRef(null);
    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    const handleKeyDown = (event) => {
        try {
            if (checkNull(scrollViewRef.current)) {
                const {key, ctrlKey, metaKey, altKey} = event;
                // console.log('key:', key, ',\tctrlKey:', ctrlKey, ',\tmetaKey:', metaKey);
                // if (key === "ArrowUp" || (key === "ArrowUp" && !ctrlKey && !metaKey)) {
                //     event.preventDefault();
                //     scrollViewRef.current.scrollTop -= scrollSpeed;
                //     console.log('ArrowUp || (ArrowUp && !ctrlKey && !metaKey)');
                // } else if (key === "ArrowDown" || (key === "ArrowDown" && !ctrlKey && !metaKey)) {
                //     event.preventDefault();
                //     scrollViewRef.current.scrollTop += scrollSpeed;
                //     console.log('ArrowDown || (ArrowDown && !ctrlKey && !metaKey)');
                // } else if ((key === "PageUp" && ctrlKey)) {
                //     event.preventDefault();
                //     scrollViewRef.current.scrollTo({
                //         top: 0, behavior: "smooth"
                //     });
                //     console.log('PageUp && ctrlKey');
                // } else if ((key === "PageDown" && ctrlKey)) {
                //     event.preventDefault();
                //     scrollViewRef.current.scrollTo({
                //         top: scrollViewRef.current.scrollHeight, behavior: "smooth"
                //     });
                //     console.log('PageDown && ctrlKey');
                // } else if ((key === "PageUp" && metaKey)) {
                //     event.preventDefault();
                //     scrollViewRef.current.scrollTo({
                //         top: 0, behavior: "smooth"
                //     });
                //     console.log('PageUp && metaKey');
                // } else if ((key === "PageDown" && metaKey)) {
                //     event.preventDefault();
                //     scrollViewRef.current.scrollTo({
                //         top: scrollViewRef.current.scrollHeight, behavior: "smooth"
                //     });
                //     console.log('PageDown && metaKey');
                // } else if (key === "Home" && ctrlKey) {
                //     event.preventDefault();
                //     scrollViewRef.current.scrollTop = 0;
                //     console.log('Home && ctrlKey');
                // } else if (key === "End" && ctrlKey) {
                //     event.preventDefault();
                //     scrollViewRef.current.scrollTop = scrollViewRef.current.scrollHeight;
                //     console.log('End && ctrlKey');
                // }
                const pageHeight = document.documentElement.clientHeight;

                if ((key === "ArrowUp" && ctrlKey) || (key === "ArrowUp" && altKey)) {
                    event.preventDefault();
                    scrollViewRef.current.scrollTop -= pageHeight / 1.3;
                    //console.log('ArrowUp && (ctrlKey || altKey)');
                } else if ((key === "ArrowDown" && ctrlKey) || (key === "ArrowDown" && altKey)) {
                    event.preventDefault();
                    scrollViewRef.current.scrollTop += pageHeight / 1.3;
                    //console.log('ArrowDown && (ctrlKey || altKey)');
                } else if (key === "ArrowUp") {
                    event.preventDefault();
                    scrollViewRef.current.scrollTop -= scrollSpeed;
                    //console.log('ArrowUp');
                } else if (key === "ArrowDown") {
                    event.preventDefault();
                    scrollViewRef.current.scrollTop += scrollSpeed;
                    //console.log('ArrowDown');
                } else if ((key === "PageUp" && ctrlKey)) {
                    event.preventDefault();
                    scrollViewRef.current.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                    //console.log('PageUp && ctrlKey');
                } else if ((key === "PageDown" && ctrlKey)) {
                    event.preventDefault();
                    scrollViewRef.current.scrollTo({
                        top: scrollViewRef.current.scrollHeight,
                        behavior: "smooth"
                    });
                    //console.log('PageDown && ctrlKey');
                } else if ((key === "PageUp" && metaKey)) {
                    event.preventDefault();
                    scrollViewRef.current.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                    //console.log('PageUp && metaKey');
                } else if ((key === "PageDown" && metaKey)) {
                    event.preventDefault();
                    scrollViewRef.current.scrollTo({
                        top: scrollViewRef.current.scrollHeight,
                        behavior: "smooth"
                    });
                    //console.log('PageDown && metaKey');
                } else if (key === "Home" && ctrlKey) {
                    event.preventDefault();
                    scrollViewRef.current.scrollTop = 0;
                    //console.log('Home && ctrlKey');
                } else if (key === "End" && ctrlKey) {
                    event.preventDefault();
                    scrollViewRef.current.scrollTop = scrollViewRef.current.scrollHeight;
                    //console.log('End && ctrlKey');
                }
            }
        } catch (e) {
            printError(TAG, 'handleKeyDown:', e);
        }
    };

    const toggleDrawer = (open) => (event, reason) => {
        // printLog(TAG, 'toggleDrawer.open:', open);
        // printLog(TAG, 'toggleDrawer.event:', event);
        // printLog(TAG, 'toggleDrawer.event.key:', event.key);
        // printLog(TAG, 'toggleDrawer.reason:', reason);
        if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        if (!open && !isBoolTrue(closeOnEscape) && event.key === "Escape") {
            return;
        }
        if (!open && !isBoolTrue(closeOnClickAway) && reason === "backdropClick") {
            return;
        }
        if (isBoolTrue(open)) {
            if (onOpen) onOpen();
            setOpenDrawer(true);
        } else {
            if (onClose) onClose();

            if (isBoolTrue(closeOnClose)) {
                setOpenDrawer(false);
            }
        }
    };

    return (<MDrawer
        anchor={getDefStr(placement, 'right')}
        open={openDrawer}
        onClose={toggleDrawer(false)}
        className={`p-0 px-0 w-100 overflow-hiddenx position-relative ${className}`}
        style={{backgroundColor: backdropColor}}
        PaperProps={{
            sx: {
                margin: isBoolTrue(detached) ? "1rem !important" : '0rem !important',
                borderRadius: isBoolTrue(detached) ? "1rem !important" : '0rem !important',
                width: (isScreenXs || isScreenSm) ? widthSm : width,
                height: isBoolTrue(detached) ? subtractSize(height, 5) : height,
                backgroundColor: `${bg} !important`, // backdropFilter: "blur(100px) !important",
                // backgroundColor: `blue !important`,
                // backdropFilter: "blur(100px) !important",
                // backgroundColor: "transparent !important",
                filter: "brightness(100%) blur(0%) !important", ...style
            },
        }}
        {...rest}>
        {createHeader()}
        {createContent()}
    </MDrawer>);

    function createHeader() {
        return <div className={`w-100 position-relativex`}>
            <div className={`px-2 py-1 m-0x d-flex ${headerClassName}`}
                 style={{...headerStyle}}>
                {/*close button*/}
                {isBoolTrue(showClose) && <Button
                    style={{
                        [(placement === 'bottom') ? 'bottom' : 'top']: '.2rem',
                        [(placement === 'left') ? 'left' : 'right']: '.2rem',
                        zIndex: 1, ...closeStyle
                    }}
                    className={`p-2 m-0 highlight-dark-hover position-absolute ${closeClassName}`}
                    variant={''}
                    circular={true}
                    width={'24px'}
                    height={'24px'}
                    iconSize={'18px'}
                    iconClass={`bi bi-x`}
                    color={closeColor}
                    onClick={toggleDrawer(false)}
                />}

                <div className={`w-100 m-0 p-0 ${titleWrapperClassName}`}>
                    {/*title*/}
                    {checkNullStr(title) && <h6
                        className={`d-flex w-100 text-blackx m-0 pt-1 p-0 fs-normal justify-content-${titleAt} ${titleClassName} d-flex w-auto`}
                        style={{fontSize: titleSize, ...titleStyle}}>{title}</h6>}

                    {titleContent && titleContent}

                    {/*subtitle*/}
                    {checkNullStr(subtitle) && <p className={`w-100 d-flex text-darkx fs-sm-md p-0 pb-0 m-0 text-wrap flex-wrap
                             text-${subtitleAt} justify-content-${subtitleAt} ${subtitleClassName}`}
                                                  style={{...subtitleStyle}}>
                        {subtitle}
                    </p>}
                </div>

                {headerContent && headerContent}
            </div>
        </div>
    }

    function createContent() {
        return <div className={`position-relative overflow-auto w-100 h-100 m-0 p-0 pb-3 ${contentClassName}`}
                    ref={scrollViewRef}
                    style={{
                        ...contentStyle
                    }}>
            {/*loading*/}
            {checkNullJson(loadingStatus) && <div className={`p-0 m-0 w-100 ${isJsonValueTrue(loadingStatus, 'loaded') ? 'mt-0' : 'mt-0'}`}>
                {!isJsonValueTrue(loadingStatus, 'loaded') && <CircleLoading wrapperClassName={'m-1'}/>}

                {checkNullStr(getJsonValue(loadingStatus, 'msg')) &&
                    <Label className={'w-100 m-0 p-1'} textAt={'center'}>{getJsonValue(loadingStatus, 'msg')}</Label>}
            </div>}

            {children}
        </div>
    }

};

export default Drawer;
